// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PanelBody-module__main--t2gpJ {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    overflow: auto;
    padding: 0 var(--panel-horizontal-padding);
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Panel/PanelBody.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,0CAA0C;AAC9C","sourcesContent":[".main {\n    margin-top: 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    overflow: auto;\n    padding: 0 var(--panel-horizontal-padding);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `PanelBody-module__main--t2gpJ`
};
export default ___CSS_LOADER_EXPORT___;
